import { render, staticRenderFns } from "./lista-solicitud-baja.vue?vue&type=template&id=4420bbd4&"
import script from "./lista-solicitud-baja.vue?vue&type=script&lang=js&"
export * from "./lista-solicitud-baja.vue?vue&type=script&lang=js&"
import style0 from "./lista-solicitud-baja.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports